import request from "../request";

export const getCertificates = () => {
	return request({
		url: "/certificate/get-all",
		type: "GET"
	});
};

export const checkBalance = (search, pin) => {
	return request({
		url: "/certificate/find",
		data: {
			search,
			pin
		}
	});
};

export const apply = (orderId, certificateUid, pin, certificateSum) => {
  return request({
    url: `/certificate/${orderId}`,
    data: {
      certificateUid,
      pin,
      certificateSum,
    },
  });
};

export const cancel = (orderId) => {
  return request({
    url: `/certificate/${orderId}`,
    type: "DELETE",
    data: {
      orderId
    }
  })
};

export const removeTicket = ({service_id, uid}) => {
	return request({
		url: "/service/cart/remove",
		type: "POST",
		data: {
			service_id,
			uid,
		}
	});
};

export const addTicket = (service_id, price_id) => {
	return request({
		url: "/service/cart/add",
		type: "POST",
		data: {
			service_id,
			price_id,
		},
	});
};

export const removeService = ({serviceId, count}) => {
	return request({
		url: "/service/cart/scope-remove",
		type: "DELETE",
		data: {
			service_id: serviceId,
			count,
		},
	});
};

export const servicesScopeAdd = ({ serviceId }) => {
	return request({
		url: '/service/cart/validate-book-form',
		type: 'POST',
		needOverlay: true,
		addCSRFToken: true,
		data: { service_id: serviceId },
	})
}

export const scopeAddRequest = (serviceId, requestData) => {
	return request({
		url: `/cart/scope-add/` + serviceId,
		type: 'POST',
		needOverlay: true,
		addCSRFToken: true,
		data: {
			...requestData,
			go_to_cart: 1
		}
	})
}
